import React, {
  useState,
  useEffect,
  useContext,
  useReducer,
  useLayoutEffect,
  useCallback,
} from 'react'
import styled from 'styled-components'
import iconEmpty from 'icons/createproject/supportneed.svg'
import {
  Button,
  Drawer,
  Form,
  Input,
  Table,
  Space,
  Select,
  Alert,
  Radio,
  Col,
  Row,
  Modal,
} from 'antd'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import { PlusOutlined, SearchOutlined, RedoOutlined } from '@ant-design/icons'
import DeletePowerBI from 'common/Management/delete'
import {
  getDataPowerBI,
  getDataPowerBIV2,
  addPowerBI,
  updatePowerBI,
  GET_COMPANY_POWERBI,
  GET_COMPANY_POWERBIV2,
  GET_COMPANY_POWERBI_NEW,
  GET_POWER_BI_OF_ID,
  GET_SEARCH_ACCOUNT,
} from 'api/Admin/powerbi'
import { getCookie } from 'helper/cookie'
import { get, includes, isEmpty, map, toUpper } from 'lodash'
import lang from 'lang/en'
import TextArea from 'antd/lib/input/TextArea'
import TreeSelectOperation from '../Tree/PowerBI/OperationTree_New'
import TreeSelectSubOperation from '../Tree/PowerBI/SuboperationTree_New'
import Company from '../Tree/PowerBI/companyV2'
const treeData = [
  {
    title: 'Node1',
    value: '0-0',
    key: '0-0',
    children: [
      {
        title: 'Child Node1',
        value: '0-0-0',
        key: '0-0-0',
      },
    ],
  },
  {
    title: 'Node2',
    value: '0-1',
    key: '0-1',
    children: [
      {
        title: 'Child Node3',
        value: '0-1-0',
        key: '0-1-0',
      },
      {
        title: 'Child Node4',
        value: '0-1-1',
        key: '0-1-1',
      },
      {
        title: 'Child Node5',
        value: '0-1-2',
        key: '0-1-2',
      },
    ],
  },
]
const PowerbiContainer = styled.div``
const EmptyContainer = styled.div``
const ContainerPowerBI = styled.div``
const Header = styled.div``
const Body = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: 1,
    // showSizeChanger: true,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
let wordError = ''
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}

const FormatGenerateKey = (state, action) => {
  switch (action.type) {
    case 'key_field':
      return state.map((parent, idxParent) => {
        const Key_parent = `0-${idxParent}`
        const handleArrayLV1 = []

        // #################### ^^ Parent Section ^^ ################

        if (parent.children !== null) {
          parent?.children?.map((childrenLV1, idxLV1) => {
            const Key_ChildrenLV1 = `0-${idxParent}-${idxLV1}`
            const handleArrayLV2 = []

            // @@@@@@@@@@@@@@@@@@@@ ^^ Children level 1 Section ^^ @@@@@@@@@@@@@@@@@@

            if (childrenLV1.children !== null) {
              childrenLV1.children?.map((childrenLV2, idxLV2) => {
                const Key_ChildrenLV2 = `0-${idxParent}-${idxLV1}-${idxLV2}`
                const state_childrenLV2 = {
                  ...childrenLV2,
                  key: Key_ChildrenLV2,
                  disabled: false,
                }
                handleArrayLV2.push(state_childrenLV2)
              })
            }

            const state_childrenLV1 = {
              ...childrenLV1,
              key: Key_ChildrenLV1,
              disabled: true,
              children: handleArrayLV2.length === 0 ? null : handleArrayLV2,
            }

            handleArrayLV1.push(state_childrenLV1)
          })
        }
        const state_parent = {
          ...parent,
          key: Key_parent,
          disabled: true,
          children: handleArrayLV1.length === 0 ? null : handleArrayLV1,
        }

        return state_parent
      })

    default:
      return state
  }
}

const { Option } = Select
// let user_type = 1
const PowerBI = (props) => {
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [dataPowerBI, setDataPowerBI] = useState(initalState.data)
  const [visible, setVisible] = useState(false)
  const [stateDrawer, setStateDrawer] = useState('')
  const [titleDrawer, setTitleDrawer] = useState('')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  const [searchedColumn, setSearchedColumn] = useState('')
  const [pagination, setPagination] = useState(initalState.pagination)
  // เช็คไอดีซ้ำ
  const [hiddenError, setHiddenError] = useState(true)
  const [form] = Form.useForm()
  const [type, setType] = useState(1)

  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const roleUser = getCookie('roleUser')

  // #################################### ---- section Company ,operation,suboperation

  const [loadingList, setIsLoadingList] = useState(false)
  const [choiceCompany, setChoiceCompany] = useState([])
  // console.log("choiceCompany", choiceCompany)
  const [choiceOperation, setChoiceOperation] = useState([])
  const [choiceSubOperation, setChoiceSubOperation] = useState([])
  const [masterData, setMasterData] = useState([])
  // console.log('masterData', masterData)
  const [accountList, setAccountList] = useState([])
  const [accountOptions, setAccountOptions] = useState([])
  const [dataRebaseCutter, setDataRebaseCutter] = useState([])
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission?.map((item) => {
        if (item.menu_id == 23) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  // console.log("datapowerbi", dataPowerBI)
  const getResultPowerBI = async () => {
    // await getDataPowerBI({
    await getDataPowerBIV2({
      token: token,
    })
      .then(async (response) => {
        // console.log(response)
        const { status, data, error } = response
        if (error) {
          setDataPowerBI([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          // console.log(data)
          setDataPowerBI(data)
          setIsLoading(false)
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initalState.pagination)
          }
        } else {
          setDataPowerBI([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataPowerBI([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getResultListCompanyBI = async () => {
    // await GET_COMPANY_POWERBIV2({
    await GET_COMPANY_POWERBI_NEW({
      token: token,
      status: 'all',
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          setMasterData(data)
          setIsLoadingList(true)
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getResultPowerBI()
      getResultListCompanyBI()
    }
  }, [token])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="mini-search-btn-admin"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className="icon" />
            {word['Search']}
          </Button>
          <Button
            type="primary"
            className="mini-search-btn-admin-reset"
            onClick={() => handleReset(clearFilters)}
          >
            {word['Reset']}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) =>
      searchedColumn === dataIndex
        ? text
        : // <Highlighter
          //   highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          //   searchWords={[this.state.searchText]}
          //   autoEscape
          //   textToHighlight={text ? text.toString() : ''}
          // />
          text,
  })

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchedColumn(dataIndex)
  }

  const params = {
    company_list: [],
  }

  const handleReset = (clearFilters) => {
    clearFilters()
  }
  const dataSource = dataPowerBI?.map((item) => ({
    id: item.id,
    code: item.code,
    local_name: item.name,
    english_name: item.name_en,
    link_url: item.report_url,
    data: item,
  }))

  const columns = [
    {
      title: <h5>Report code</h5>,
      dataIndex: 'code',
      sorter: (a, b) => a.code.localeCompare(b.code),
      width: 140,
      ellipsis: true,
      // align: 'center',
      ...getColumnSearchProps('code'),
    },
    {
      title: <h5>Local report name</h5>,
      dataIndex: 'local_name',
      width: 180,
      sorter: (a, b) => a.local_name.localeCompare(b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local_name'),
    },
    {
      title: <h5>English report name</h5>,
      dataIndex: 'english_name',
      width: 180,
      sorter: (a, b) => a.english_name.localeCompare(b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english_name'),
    },
    {
      title: <h5>Embedded link</h5>,
      dataIndex: 'link_url',
      width: 180,
      sorter: (a, b) => a.link_url.localeCompare(b.link_url),
      ellipsis: true,
      ...getColumnSearchProps('link_url'),
    },
  ]
  function onChange(pagination2, filters, sorter, extra) {
    if (pagination !== false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }
  const onChangeUnitCode = (event) => {
    form.setFieldsValue({
      code: event.target.value.replace(/\s/g, ''),
    })
  }
  const onFinish = (value) => {
    const CompanyJoinerString = choiceCompany?.join(',')
    const OperationJoinerString = choiceOperation?.join(',')
    const SubOperationJoinerString = choiceSubOperation?.join(',')
    const { radio_choice, user_select } = form.getFieldValue()
    const accountSelectedListString = user_select?.join(',')

    if (stateDrawer === 'add') {
      const data = {
        code: value.code,
        name: value.name,
        name_en: value.eng_name,
        report_url: value.linkEmbed,
        company_id: CompanyJoinerString,
        operation_id: OperationJoinerString,
        suboperation_id: SubOperationJoinerString,
        typechoose: radio_choice,
        choose_id: accountSelectedListString,
      }
      try {
        addPowerBI({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getResultPowerBI()
            setVisible(false)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_report_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
          // setDataRebaseCutter([])
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      const data = {
        id: dataEdit.id,
        code: value.code,
        name: value.name,
        name_en: value.eng_name,
        report_url: value.linkEmbed,
        company_id: CompanyJoinerString,
        operation_id: OperationJoinerString,
        suboperation_id: SubOperationJoinerString,
        typechoose: radio_choice,
        choose_id: accountSelectedListString,
      }
      try {
        updatePowerBI({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getResultPowerBI()
            setVisible(false)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_report_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
          // setDataRebaseCutter([])
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const onFailed = (value) => {
    // console.log(value)
  }

  const modalDelete = () => {
    return (
      <DeletePowerBI
        visibleDelete={visibleDelete}
        setVisibleDelete={setVisibleDelete}
        state={'powerBI'}
        data={dataEdit}
        renderData={getResultPowerBI}
        setVisibleDrawer={setVisible}
      />
    )
  }

  // add powerbi
  const eventAdd = () => {
    form.setFieldsValue({
      code: null,
      name: null,
      eng_name: null,
      linkEmbed: null,
      radio_choice: 1,
    })
    setType(1)
    setChoiceCompany([])
    setChoiceOperation([])
    setChoiceSubOperation([])
    setAccountOptions([])
    // setDataRebaseCutter([])

    setHiddenError(true)
    setVisible(true)
    setStateDrawer('add')
    setTitleDrawer('Add Power BI Report')
  }
  // edit powerbi
  const eventEdit = async (data) => {
    // console.log('data', data)
    permissionPage.update ? setDisablePage(false) : setDisablePage(true)
    form.setFieldsValue({
      code: data.code,
      name: data.local_name,
      eng_name: data.english_name,
      linkEmbed: data.link_url,
      radio_choice: data.data.typechoose,
    })
    const CompanyFormat = data.data.company_id.split(',')
    const OperationFormat = data.data.operation_id.split(',')
    const SubOperationFormat = data.data.suboperation_id.split(',')
    const userFormat = data.data.choose_id.split(',')

    const newCompany = CompanyFormat?.filter((i) => i !== '')
    const newOperation = OperationFormat?.filter((i) => i !== '')
    const newSubOperation = SubOperationFormat?.filter((i) => i !== '')
    const newUserFormat = userFormat?.filter((u) => u !== '')

    const CompanyFirstSearch = newCompany?.join(',')
    const OperationFirstSearch = newOperation?.join(',')
    const SubOperationFirstSearch = newSubOperation?.join(',')
    const EditResearch = {
      search: '',
      company_id: CompanyFirstSearch,
      operation_id: OperationFirstSearch,
      suboperation_id: SubOperationFirstSearch,
    }

    // console.log("CompanyFirstSearch", CompanyFirstSearch)

    setChoiceCompany(newCompany)
    setChoiceOperation(newOperation)
    setChoiceSubOperation(newSubOperation)

    form.setFieldsValue({
      user_select: newUserFormat,
      radio_choice: data.data.typechoose,
    })

    setType(data.data.typechoose)
    setHiddenError(true)
    setDataEdit(data)
    setStateDrawer('edit')
    setTitleDrawer('Edit Power BI Report')
    setVisible(true)
    await getResultAccountBysearch(EditResearch)
    // await FindOFID_PowerBI(data.data.id)
  }
  const onClose = (value) => {
    setVisible(false)
  }
  const renderButton_Drawer = () => {
    if (stateDrawer === 'add') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className="BTN_Next" onClick={form.submit}>
            {word['Save']}
          </Button>
        </div>
      )
    } else {
      return (
        <div style={{ textAlign: 'right' }}>
          <Button
            hidden={permissionPage.delete ? false : true}
            className="BTN_Delete_CPF_RED"
            onClick={() => setVisibleDelete(true)}
            style={{ marginRight: 8 }}
          >
            {word['Delete']}
          </Button>
          <Button
            hidden={permissionPage.update ? false : true}
            className="BTN_Next"
            onClick={form.submit}
            type="primary"
          >
            {word['Save']}
          </Button>
        </div>
      )
    }
  }

  const content = () => {
    if (dataPowerBI?.length > 0) {
      return (
        <ContainerPowerBI>
          <Header className="layout-button-add-normal-state">
            <div className="layout-btn-reset-add">
              <Button
                onClick={eventAdd}
                icon={<PlusOutlined className="Icon-color" />}
                className="BTN_Next"
                hidden={permissionPage.create ? false : true}
              >
                Add Power BI Report
              </Button>
              <Button
                type="primary"
                style={{ marginLeft: 8 }}
                className="btn_Secondary2"
                onClick={() => window.location.reload()}
              >
                <RedoOutlined className="Icon-color" />
                {word['Reset']}
              </Button>
            </div>
          </Header>
          <Body>
            <Table
              key="powerbi"
              onRow={(record) => {
                return {
                  onClick: () => {
                    if (loadingList) {
                      eventEdit(record)
                    }
                  }, // click row
                }
              }}
              columns={columns}
              dataSource={dataSource}
              onChange={onChange}
              pagination={pagination}
              showSorterTooltip={false}
            />
          </Body>
        </ContainerPowerBI>
      )
    } else {
      return (
        <EmptyContainer className="initialstate-container">
          <img src={iconEmpty} />
          <h2>Please add Power BI Report in your project (optional)</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            onClick={eventAdd}
            icon={<PlusOutlined className="Icon-color" />}
            className="btn_Secondary2"
          >
            Add Power BI Report
          </Button>
        </EmptyContainer>
      )
    }
  }

  // const uuu = () => {
  //   const array = [10, 8, 2, 5, 1]
  //   const array2 = [1, 2, 3, 4, 5, 10, 11]
  //   // const newArray = array.filter((item, index) => array.indexOf(item) !== index)
  //   // console.log(newArray)
  //   // var array3 = array.filter(function (obj) { return array2.indexOf(obj) !== -1 })
  //   var array3 = array.filter(function (obj) { return array2.indexOf(obj) !== -1 })
  //   console.log(array3)
  // }
  // uuu()

  const getResultAccountBysearch = async (item, check) => {
    const UltimateParams = {
      company_id: item.company_id,
      operation_id: item.operation_id,
      suboperation_id: item.suboperation_id,
      search: item.search,
    }
    // console.log(UltimateParams);
    await GET_SEARCH_ACCOUNT({
      params: UltimateParams,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setAccountOptions([])
          setAccountList([])
          return true
        }
        if (status === 200) {
          setAccountList(data.data)
          if (check === 'checking') {
            const arrayUser_Select = form.getFieldValue('user_select')
            const dataListID = data.data?.map((u) => {
              return String(u.id)
            })
            let arraySelect = []
            arrayUser_Select.map((item) => {
              if (dataListID.includes(item)) {
                arraySelect.push(String(item))
              }
            })
            form.setFieldsValue({ user_select: arraySelect })
          }
        } else if (status === 404) {
          if (check === 'checking') {
            setAccountOptions([])
            form.setFieldsValue({ user_select: [] })
          }
        } else {
          setAccountOptions([])
          setAccountList([])
          return true
        }
      })
      .catch((error) => {
        setAccountOptions([])
        setAccountList([])
        console.error(error)
      })
  }

  // const FindOFID_PowerBI = async (propsID) => {

  //   await GET_POWER_BI_OF_ID({
  //     token: token,
  //     powerBi_id: String(propsID)

  //   })
  //     .then(async (response) => {
  //       const { status, data, error } = response
  //       if (error) {
  //         return true
  //       }
  //       if (status === 200) {
  //         const newData = data.choose_account?.map((item) => {
  //           const newObject = {
  //             account_id: item.account_id,
  //             firstname: item.firstname,
  //             lastname: item.lastname,
  //             company_id: item.company_id,
  //             operation_id: item.operation_id,
  //             suboperation_id: item.operation_id
  //           }
  //           return newObject
  //         }
  //         )
  //         setDataRebaseCutter(newData)
  //       } else {
  //         return true
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error)
  //     })
  // }

  useEffect(() => {
    if (!isEmpty(accountList)) {
      const option = map(accountList, (data) => {
        const id = String(get(data, 'id'))
        const firstname = get(data, 'firstname', id)
        const lastname = get(data, 'lastname', id)
        return { label: firstname + ' ' + lastname, value: id, data: data }
      })

      setAccountOptions(option)
    }
  }, [accountList])

  const RebaseCutterFunctionally = async (from, valueCom, valueOper, valueSub) => {
    let arrayCompany = []
    let arrayOperation = []
    let arraySuboperation = []
    if (from === 'from company') {
      arrayCompany = valueCom
      masterData.map((p) => {
        if (valueCom.includes(p.value)) {
          p.children?.map((c) => {
            if (valueOper?.includes(c?.value)) {
              arrayOperation.push(c.value)
              c.children?.map((cc) => {
                if (valueSub.includes(cc.value)) {
                  arraySuboperation.push(cc.value)
                }
              })
            }
          })
        }
      })
    } else if (from === 'from operation') {
      arrayCompany = valueCom
      arrayOperation = valueOper
      masterData.map((p) => {
        if (valueCom.includes(p.value)) {
          p.children?.map((c) => {
            if (valueOper?.includes(c?.value)) {
              c.children?.map((cc) => {
                if (valueSub.includes(cc.value)) {
                  arraySuboperation.push(cc.value)
                }
              })
            }
          })
        }
      })
    } else {
      arrayCompany = valueCom
      arrayOperation = valueOper
      arraySuboperation = valueSub
    }
    const Params = {
      company_id: arrayCompany.join(','),
      operation_id: arrayOperation.join(','),
      suboperation_id: arraySuboperation.join(','),
      search: '',
    }
    // console.log(arrayCompany, arrayOperation, arraySuboperation)
    await getResultAccountBysearch(Params, 'checking')
  }

  // const onChangeAccount = (id, data) => {
  // console.log(data)
  // const filterRingObjectError = data.filter((ob) => { if (ob.label) { return ob } })
  // console.log(filterRingObjectError)
  // const newData = filterRingObjectError?.map((item) => {
  //   const newObject = {
  //     account_id: item.data?.id,
  //     firstname: item.data?.firstname,
  //     lastname: item.data?.lastname,
  //     company_id: item.data?.company_id,
  //     operation_id: item.data?.operation_id,
  //     suboperation_id: item.data?.operation_id
  //   }
  //   return newObject
  // })
  // console.log(newData)
  // setDataRebaseCutter(newData)
  // }
  function onSearchAccount(value) {
    if (value.length >= 1) {
      const CompanyJoinerString = choiceCompany.join(',')
      const OperationJoinerString = choiceOperation.join(',')
      const SubOperationJoinerString = choiceSubOperation.join(',')

      const EditResearch = {
        search: value,
        company_id: CompanyJoinerString,
        operation_id: OperationJoinerString,
        suboperation_id: SubOperationJoinerString,
      }

      getResultAccountBysearch(EditResearch)
    }
  }
  function onChangeRadio(e) {
    form.setFieldsValue({
      user_select: [],
      radio_choice: e.target.value,
    })
    setType(e.target.value)
  }
  const UserSelectInput = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
        }}
      >
        <Form.Item
          name="user_select"
          style={{ marginBottom: 0 }}
          rules={[
            {
              required: true,
              message: 'Allow Only, at least 1 person is required.',
            },
          ]}
        >
          <Select
            placeholder="Search name"
            maxTagCount="responsive"
            mode="multiple"
            // onChange={(id, data) => onChangeAccount(id, data)}
            // onSelect={(id, data) => onSelectAccount(id, data)}
            onSearch={onSearchAccount}
            style={{ width: '100%', marginLeft: 16, minWidth: 300, maxWidth: 500 }}
            filterOption={(input, option) => {
              const label = get(option, 'label', '')
              return label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }}
            options={accountOptions}
          />
        </Form.Item>
      </div>
    )
  }

  return (
    <PowerbiContainer
      style={{ padding: 32 }}
      className="layout-git-master-unitmeasurment"
    >
      {content()}
      <Modal
        maskClosable={false}
        title={<TextTitleBold>{titleDrawer}</TextTitleBold>}
        onCancel={onClose}
        visible={visible}
        width={'634px'}
        className="fix-modal"
        footer={renderButton_Drawer()}
        destroyOnClose
        centered
      >
        <Form
          className="disable-page tag-style-input"
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFailed}
          // hideRequiredMark
        >
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError} style={{ marginBottom: 10 }}>
              <Alert message={wordError} type="error" showIcon />
            </div>
            <Form.Item
              id="code"
              name="code"
              label={<h4>Report Code</h4>}
              className="customValidation"
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Please enter report code',
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Please enter report code"
                maxLength={10}
                onChange={onChangeUnitCode}
                onKeyUp={(e) =>
                  form.setFieldsValue({
                    code: toUpper(e.target.value),
                  })
                }
              />
            </Form.Item>
            <Form.Item
              id="name"
              name="name"
              label={<h4>Local Report Name</h4>}
              className="customValidation"
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Please enter local report name',
                },
              ]}
            >
              <Input size="large" placeholder="Please enter local report name" />
            </Form.Item>
            <Form.Item
              id="eng_name"
              name="eng_name"
              label={<h4>English Report Name</h4>}
              className="customValidation"
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Please enter english report name',
                },
              ]}
            >
              <Input size="large" placeholder="Please enter english report name" />
            </Form.Item>
            <Form.Item
              id="linkEmbed"
              name="linkEmbed"
              label={<h4>Embedded Link</h4>}
              className="customValidation"
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Please enter embedded link',
                },
              ]}
            >
              <TextArea rows={4} size="large" placeholder="Please enter embedded link" />
            </Form.Item>
            <Form.Item id="company" name="company" label={<h4>Business</h4>}>
              <Company
                RebaseCutterFunctionally={RebaseCutterFunctionally}
                form={form}
                setAccountOptions={setAccountOptions}
                setAccountList={setAccountList}
                masterData={masterData}
                choiceCompany={choiceCompany}
                defaultCompanyName={
                  dataEdit?.company_name || dataEdit?.data?.company_name
                }
                choiceOperation={choiceOperation}
                choiceSubOperation={choiceSubOperation}
                setChoiceCompany={setChoiceCompany}
                setChoiceOperation={setChoiceOperation}
                setChoiceSubOperation={setChoiceSubOperation}
                setType={setType}
              />
            </Form.Item>
            <Form.Item id="operation" name="operation" label={<h4>Operation</h4>}>
              <TreeSelectOperation
                RebaseCutterFunctionally={RebaseCutterFunctionally}
                form={form}
                setAccountOptions={setAccountOptions}
                setAccountList={setAccountList}
                masterData={masterData}
                choiceCompany={choiceCompany}
                choiceOperation={choiceOperation}
                defaultOperationName={
                  dataEdit?.operation_name || dataEdit?.data?.operation_name
                }
                choiceSubOperation={choiceSubOperation}
                setChoiceOperation={setChoiceOperation}
                setChoiceSubOperation={setChoiceSubOperation}
                setType={setType}
              />
            </Form.Item>
            <Form.Item
              id="sub_operation"
              name="sub_operation"
              label={<h4>Project type</h4>}
            >
              <TreeSelectSubOperation
                RebaseCutterFunctionally={RebaseCutterFunctionally}
                form={form}
                setAccountOptions={setAccountOptions}
                setAccountList={setAccountList}
                masterData={masterData}
                choiceCompany={choiceCompany}
                choiceOperation={choiceOperation}
                defaultSubOperationName={
                  dataEdit?.sub_operation_name || dataEdit?.data?.sub_operation_name
                }
                choiceSubOperation={choiceSubOperation}
                setChoiceSubOperation={setChoiceSubOperation}
                setType={setType}
              />
            </Form.Item>
            <Row>
              <Form.Item
                id="radio_choice"
                name="radio_choice"
                className="item-style-radio"
                label={<h4>User</h4>}
              >
                <Radio.Group onChange={onChangeRadio}>
                  <Space direction="vertical">
                    <Radio value={1}>Select All</Radio>
                    <Radio value={2}>Allow Only...</Radio>
                    {[2].includes(type) ? UserSelectInput() : <></>}
                    <Radio value={3}>Except...</Radio>
                    {[3].includes(type) ? UserSelectInput() : <></>}
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Row>
          </fieldset>
        </Form>
        {modalDelete()}
      </Modal>
    </PowerbiContainer>
  )
}
export default PowerBI
